import { render } from "./iconArrowRight.vue?vue&type=template&id=f308d67e"
import script from "./iconArrowRight.vue?vue&type=script&lang=js"
export * from "./iconArrowRight.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__